import {PayloadAction} from "../payload-action.interface";
import {SettingEntity} from "./setting.entity";
import {SettingActions} from "./setting.actions";

export function SettingReducer(state: SettingEntity = null, action: PayloadAction) {

  switch (action.type) {
    case SettingActions.SET:
    case SettingActions.ADD:
      return state = action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/setting/setting.reducer.ts